import { MessageCircle } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import DraggableWrapper from './DraggableWrapper';

const ChatFloatingButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === '/chat') {
    return null;
  }

  return (
    <DraggableWrapper initialBottom={28} initialRight={6}>
      <button
        onClick={() => navigate('/chat')}
        className="bg-gradient-to-r from-purple-400 to-purple-600 text-white rounded-full p-3 shadow-lg hover:shadow-xl transition-all group"
        title="Xat amb IA"
        data-testid="chat-floating-btn"
      >
        <MessageCircle className="w-5 h-5" />
      </button>
    </DraggableWrapper>
  );
};

export default ChatFloatingButton;
